module.exports = __webpack_public_path__ + "static/img/1.20bb15e4.jpg";